<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VZAPfO/tc-custom/9781684813957.jpg?1718219586396" alt="This image is the cover for the book Radiant Faith"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Radiant Faith
      </h1>
      <p class="bookDescription body article font2">
        <b>A Radiant Daily Devotional for Teenage Girls</b><p></p><p><b>#1 New Release in Teen &amp; Young Adult Biblical Studies</b><br/></p><p><b><i>Radiant Faith</i> by M.J. Fievre is a 52-week devotional guide designed to help teenage girls deepen their faith and spiritual connection. By incorporating personal stories, scripture, and prayer, this guide aims to inspire and empower teenage girls to live confidently in their faith.</b></p><p></p><p><b>Seeking an empowering daily devotional for spiritual and personal growth?</b><i>Radiant Faith</i> is the christian journal book to kickstart your spiritual journey. With daily readings, reflection questions, and journaling pages, you’ll grow your faith and connection with God.   </p><p><b>Thrive with this spiritual and personal growth book. </b>This 52-week devotional for teenage girls equips teenage readers with tools and questions to ignite their passion for God while building confidence and resilience in their faith. </p><p><b>Inside, you’ll find:</b></p>52 weekly Christian devotionals exploring crucial themes for teenage girlsPractical advice and encouragement to help teenage girls navigate daily challengesRelatable stories and reflection questions that foster a sense of identity and sisterhood<p></p><p></p><p><b>If you're looking for Christian books or books for teenage girls, add this to your cart! If you liked <i>Fearless Faith</i>, <i>Choose Kindness</i>, or <i>Prayers for Calm</i>, you’ll love <i>Radiant Faith</i>.</b></p>

      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M.J. Fievre
      </h2>
      
      <p class="authorDescription body article"><B>M.J. Fievre, B.S. Ed.</B>, is a devoted Christian writer and educator who has dedicated her life to guiding and inspiring teens on their spiritual journey. Born and raised in a Christian household, she received her foundational education at the Catholic school, Sainte Rose de Lima. During her time there, MJ engaged in in-depth Bible studies, fostering a deep understanding of Christian teachings. As a leader of &#34;Jeunesse Mariale,&#34; a Catholic youth movement in Port-au-Prince, she mentored her peers, helping them to deepen their understanding of Christianity and fuel their spiritual growth. Continuing her spiritual education, MJ attended Notre Dame of Haiti in Port-au-Prince and later transferred to Barry University, both Catholic institutions. Her dedication to her faith and community is evident through her active involvement in her church's dream team, where she serves in the children's program. Her extensive experience in faith-based education, service, and her background as an accomplished author with a strong track record in sales make her the ideal choice for crafting a devotional guide like Radiant Faith. Through this book, MJ aims to inspire and empower young women to deepen their spiritual connection and navigate the challenges they face daily. She lives in Winter Garden, Florida.&#10;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Mango Publishing Group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?700aa520